function triggerBrowserDownload(url, fileName) {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (fileName) {
        anchor.download = fileName;
    }
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

export async function downloadSignedFile(url, fileName, signal) {
    const response = await fetch(url, {signal});
    if (!response.ok) {
        throw new Error(`Failed to download ${fileName || 'file'}`);
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    triggerBrowserDownload(downloadUrl, fileName);
    window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
    return blob.size || 0;
}

